var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_53)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7142 0.716948C16.9332 -0.0641007 15.6668 -0.0641006 14.8858 0.716948L13.6635 1.93921L18.5465 6.82216L19.7687 5.5999C20.5498 4.81885 20.5498 3.55252 19.7687 2.77147L17.7142 0.716948ZM17.1451 8.22353L12.2621 3.34058L2.46782 13.1349C2.26632 13.3364 2.11021 13.5786 2.00994 13.8454L0.772375 17.1375C0.167626 18.7462 1.73951 20.3181 3.34822 19.7133L6.64032 18.4757C6.90705 18.3755 7.14928 18.2194 7.35077 18.0179L17.1451 8.22353Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.599ab6b748f11f4e394dae9356ff10b7.svg";
export { ForwardRef as ReactComponent };